import { CalendarFavorite02Icon, CompassIcon } from '@hugeicons/react'

import { Card } from '@/shared/ui/Card'

import { MatchedTagList } from './MatchedTagList'

import type {
  SuggestedJourney,
  SuggestedProgramming,
  Suggestion
} from '../model/types'

const formatStartAt = (value: string | null): string | null => {
  if (!value) return null

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null

  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const ProgrammingSuggestionCard = ({
  suggestion
}: {
  suggestion: Suggestion<SuggestedProgramming>
}) => {
  const { record, matched_tags: matchedTags } = suggestion
  const startAt = formatStartAt(record.start_at)

  return (
    <Card href="/programacao" className="p-4">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-[0.625rem] bg-brand-surface">
          {record.participant_image?.file?.url ? (
            <img
              src={record.participant_image.file.url}
              alt=""
              className="h-full w-full object-cover"
            />
          ) : (
            <CalendarFavorite02Icon
              size={20}
              className="text-primary opacity-45"
            />
          )}
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-base font-semibold text-foreground">
            {record.name}
          </p>

          {startAt && (
            <p className="mt-0.5 text-sm text-gray-700">{startAt}</p>
          )}

          <div className="mt-3">
            <MatchedTagList tags={matchedTags} />
          </div>
        </div>
      </div>
    </Card>
  )
}

export const JourneySuggestionCard = ({
  suggestion
}: {
  suggestion: Suggestion<SuggestedJourney>
}) => {
  const { record, matched_tags: matchedTags } = suggestion

  return (
    <Card href={`/jornadas/${record.id}`} className="p-4">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-[0.625rem] bg-brand-surface">
          {record.cover?.file?.url ? (
            <img
              src={record.cover.file.url}
              alt=""
              className="h-full w-full object-cover"
            />
          ) : (
            <CompassIcon size={20} className="text-primary opacity-45" />
          )}
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-base font-semibold text-foreground">
            {record.name}
          </p>

          {record.description && (
            <p className="mt-0.5 line-clamp-2 text-sm text-gray-700">
              {record.description}
            </p>
          )}

          <div className="mt-3">
            <MatchedTagList tags={matchedTags} />
          </div>
        </div>
      </div>
    </Card>
  )
}
